import { default as apiModule, Api } from '../api/api.module'
import { default as commonModule, LoggerService } from '../common/common.module'

import { IUserSession } from '../../helpers'

import { LoginController } from './login.controller'
import { StateProvider, StateService } from '@uirouter/angularjs'

import './login.scss'
import * as TEMPLATE from './login.tpl.html'

var moduleName = 'simax.login'
var module = angular.module(moduleName, [commonModule, apiModule])

module.controller('LoginController', ['$scope', '$state', '$location', '$q', 'api', 'logger', 'userSession', (
    $scope,
    $state: StateService,
    $location: ng.ILocationService,
    $q: ng.IQService,
    api: Api,
    logger: LoggerService,
    userSession: IUserSession
) => new LoginController($scope, $state, $location, $q, api, logger, userSession)])

module.config(['$stateProvider', ($stateProvider: StateProvider) => {
    $stateProvider.state('login', {
        url: '/login',
        controller: 'LoginController',
        template: TEMPLATE
    }).state('reset', {
        url: '/reset',
        controller: 'LoginController',
        template: TEMPLATE
    })
}])

export default moduleName
